const about = {
  hero: {
    badge: "Our Story",
    title: "Family, Trust & Dedication",
    subtitle: "We are Adry & Mich — a family-owned business built on hard work, honesty, and a genuine love for helping our community.",
  },
  story: {
    title: "Who We Are",
    p1: "Based in Royal Palm Beach, FL, we started Adry & Mich Cleaning and Handyman Service with one simple goal: to take care of your home so you don't have to worry about it.",
    p2: "As a family-owned business, we bring a personal touch to every job. We treat your home like our own — with care, respect, and attention to every detail.",
    p3: "From regular cleaning to complex repairs, we are your all-in-one home care solution. Our clients trust us because we show up, we do the job right, and we always communicate openly.",
    years: "Years of Experience",
    clients: "Happy Clients",
    rating: "Average Rating",
  },
  values: {
    title: "Our Values",
    items: [
      {
        icon: "ri-heart-line",
        title: "Family First",
        desc: "We treat every client like family. Your home is our responsibility, and we take that seriously.",
      },
      {
        icon: "ri-shield-check-line",
        title: "Trust & Honesty",
        desc: "We are transparent about pricing, timing, and what we can do. No surprises, no hidden fees.",
      },
      {
        icon: "ri-medal-line",
        title: "Quality Work",
        desc: "We don't leave until the job is done right. Your satisfaction is our standard.",
      },
    ],
  },
  area: {
    title: "Our Service Area",
    subtitle: "We proudly serve Royal Palm Beach and surrounding areas in Palm Beach County, FL — no matter where you are, we've got you covered.",
    areas: ["Royal Palm Beach", "Wellington", "West Palm Beach", "Palm Beach Gardens", "Lake Worth", "Boynton Beach"],
  },
  schedule: {
    title: "Business Hours",
    days: "Monday – Saturday",
    hours: "8:00 AM – 4:00 PM",
    note: "Available for emergency services — contact us!",
  },
  payment: {
    title: "Payment Methods",
    methods: ["Cash", "Zelle", "Check"],
  },
};

export default about;
